import React from 'react';

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'reading' | 'content' | 'full';
  children: React.ReactNode;
}

export const Container: React.FC<ContainerProps> = ({
  size = 'content',
  children,
  style,
  className,
  ...props
}) => {
  let maxWidth = 'var(--nev-content-max, 1440px)';
  if (size === 'reading') {
    maxWidth = 'var(--nev-reading-max, 680px)';
  } else if (size === 'full') {
    maxWidth = '100%';
  }

  const containerStyle: React.CSSProperties = {
    width: '100%',
    maxWidth,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: 'var(--nev-gutter, 20px)',
    paddingRight: 'var(--nev-gutter, 20px)',
  };

  return (
    <div
      className={`nev-container ${className ?? ''}`}
      style={{ ...containerStyle, ...style }}
      {...props}
    >
      {children}
    </div>
  );
};
